<ion-item lines="none">
  <span class="icon" slot="start" [ngClass]="statusClass"></span>
  <span class="question">{{ question }}</span>
</ion-item>
<ion-item lines="none">
  <span class="status">{{ consentStatus }}</span>
</ion-item>
